var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgElectricIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "premiumIcon",
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M15 0C6.718 0 0 6.718 0 15s6.718 15 15 15 15-6.718 15-15S23.282 0 15 0zm-.782 27.024v-9.409h-5.23l7.515-14.639v9.409h5.035l-7.32 14.639z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgElectricIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/electric-icon.3ba7734aabe725598d3b4e8e0aeeab29.svg";